import { render, staticRenderFns } from "./ProfileDialog.vue?vue&type=template&id=5a32928b&scoped=true&"
import script from "./ProfileDialog.vue?vue&type=script&lang=js&"
export * from "./ProfileDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDialog.vue?vue&type=style&index=0&id=5a32928b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a32928b",
  null
  
)

export default component.exports